import React from "react"

export default function ResultView({ result, bookingUrl, onRestart }) {
  return (
    <div>
      <p className={`result-band ${result.band === 'HIGH-RISK ZONE' ? 'risk' : ''}`}>{result.band}</p>
      <h2 className="result-title">{result.title}</h2>

      <p className="result-body">
        {result.before}
        <strong>{result.strong}</strong>
        {result.after}
      </p>

      <div className="text-center">
        <a
          className="cta-btn"
          href={bookingUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          Book a 20-minute readiness call
        </a>
      </div>

      <button className="restart" onClick={onRestart}>
        Retake the check
      </button>
    </div>
  )
}
